import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { ICatalogWithInfo } from '../models/request-and-responses/rest-api/interfaces/catalogWithInfo';
import { ICityResponse } from '../models/request-and-responses/rest-api/interfaces/cityResponse';
import { IVendorResponse } from '../models/request-and-responses/rest-api/interfaces/distributorResponse';
import { IFileUserLink } from '../models/request-and-responses/rest-api/interfaces/fileUserLink';
import { IFileWithInfo } from '../models/request-and-responses/rest-api/interfaces/fileWithInfo';
import { IProvinceResponse } from '../models/request-and-responses/rest-api/interfaces/provinceResponse';
import { IShadowCustomerCreate } from '../models/request-and-responses/rest-api/interfaces/shadowCustomerCreate';
import { IShadowGenericAnagraphic } from '../models/request-and-responses/rest-api/interfaces/shadowGenericAnagraphic';
import { ISupplierResponse } from '../models/request-and-responses/rest-api/interfaces/supplierResponse';
import { IUserInfoCreate } from '../models/request-and-responses/rest-api/interfaces/userInfoCreate';
import { IUserWithAnagraphic } from '../models/request-and-responses/rest-api/interfaces/userWithAnagraphic';
import { IUserWithAnagraphicGroup } from '../models/request-and-responses/rest-api/interfaces/userWithAnagraphicGroup';
import { IView } from '../models/request-and-responses/rest-api/interfaces/view';
import { CatalogType } from '../models/request-and-responses/rest-api/enums/catalogType.enum';
import { SieveOperator, SieveString } from '../helpers/sieve/sieveString.class';
import { Observable } from 'rxjs/Observable';
import {
    IPataviumPagedResponse,
    IPataviumResponse,
    IPataviumResponseFirstItem,
    PataviumPagedResponse,
    PataviumPagedResponseFirstItem
} from '../helpers/response.class';
import { IVatExemptionDto } from '../models/request-and-responses/rest-api/interfaces/vatExemptionDto';
import { City, ICity } from '../helpers/city.class';
import { ICatalog } from '../models/request-and-responses/rest-api/interfaces/catalog';
import { INotificationListResponse } from '../models/request-and-responses/rest-api/interfaces/notificationListResponse';
import { IFlatUser } from '../models/request-and-responses/rest-api/interfaces/flatUser';
import { ITableStorageInfo } from '../models/request-and-responses/rest-api/interfaces/tableStorageInfo';
import { BrandType } from '../models/request-and-responses/rest-api/enums/brandType';
import { PairUsersAvatar } from '../models/request-and-responses/rest-api/interfaces/pairUsersAvatar';
import { concatMapTo, map, mergeMap, retryWhen, switchMap } from 'rxjs/operators';
import { throwError, timer } from 'rxjs';
import { SieveFilter } from '../helpers/sieve/sieve-filters-and-sorts';
import { SupplyType } from '../models/request-and-responses/rest-api/enums/SupplyType';
import { ISupplyOffer } from '../models/request-and-responses/rest-api/interfaces/supplyOffer';
import { AssocUserCatalog } from '../models/request-and-responses/rest-api/classes/assocUserCatalog';
import { StorageFile } from '../models/request-and-responses/rest-api/classes/storageFile';
import { IVeryShortCatalog } from '../models/request-and-responses/rest-api/interfaces/veryShortCatalog';
import { IVeryShortUser } from '../models/request-and-responses/rest-api/interfaces/veryShortUser';
import { ICreateLockRequest } from '../models/request-and-responses/rest-api/interfaces/createLockRequest';
import { ICreateLockResponse } from '../models/request-and-responses/rest-api/interfaces/createLockResponse';
import { IRefreshLockRequest } from '../models/request-and-responses/rest-api/interfaces/refreshLockRequest';
import { ITimestampInfos } from '../models/request-and-responses/rest-api/classes/timestampInfos';
import { ContractCreationFileType } from '../pages/common/contract-from-file/contract-creation-file.type';
import {
    ContractsCreationFromCsvResponse,
    IContractsCreationFromCsvResponse
} from '../models/request-and-responses/rest-api/interfaces/contractsCreationFromFileResponse';
import { AreraFileType } from '../models/request-and-responses/rest-api/enums/AreraFileType';
import { ICatalogAreraGasGeoPartitionFileResp } from '../models/request-and-responses/rest-api/interfaces/catalogAreraGasGeoPartitionFileResp';
import { AreraGeoPartitionName } from '../models/request-and-responses/rest-api/enums/AreraGeoPartitionName';
import { PataviumRole } from '../models/request-and-responses/rest-api/enums/role.enum.model';
import { IPairAnagraphicUserRole } from '../models/request-and-responses/rest-api/interfaces/pairAnagraphicUsersRoles';
import { ISms } from '../models/request-and-responses/rest-api/interfaces/sms.interface';
import { ISmsUsers } from '../models/request-and-responses/rest-api/interfaces/sms-users.interface';
import { IUser } from '../models/request-and-responses/rest-api/interfaces/user';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import { IPortaUnAmicoResponse } from '../models/request-and-responses/rest-api/interfaces/portaunamicoResponse';
import { IInviteResponse } from '../models/request-and-responses/rest-api/interfaces/inviteResponse';
import { IInviteRequest } from '../models/request-and-responses/rest-api/interfaces/inviteRequest';

@Injectable()
export class DataService {

    constructor(private router: Router, private http: HttpClient) {
    }

    /* VIEW PERMISSIONS ###########################################################################*/
    getViewPermissions(sieveString: SieveString): Observable<IPataviumPagedResponse<IView>> {
        return this.http.get<IPataviumPagedResponse<IView>>(
            environment.apiUrl + '/views' + sieveString.toString()
        );
    }

    changeViewPermission(
        idView: number,
        canbevisited: boolean
    ): Observable<IPataviumPagedResponse<IView>> {
        return this.http.put<IPataviumPagedResponse<IView>>(
            environment.apiUrl + '/views/' + idView + '/canbevisited/' + canbevisited,
            null
        );
    }

    updateView(view: IView): Observable<IPataviumPagedResponse<IView>> {
        return this.http.put<IPataviumPagedResponse<IView>>(environment.apiUrl + '/views', view);
    }

    /** USERS #####################################################################################*/
    whoAmI(): Observable<IPataviumResponseFirstItem<IUserWithAnagraphic>> {
        return this.http
            .get<IPataviumPagedResponse<IUserWithAnagraphic>>(environment.apiUrl + '/users/me', {})
            .pipe(map(response => new PataviumPagedResponseFirstItem(response)));
    }

    getUsers(sieveString: SieveString): Observable<IPataviumPagedResponse<IUserWithAnagraphic>> {
        return this.http.get<IPataviumPagedResponse<IUserWithAnagraphic>>(
            environment.apiUrl + '/users' + sieveString.toString()
        );
    }

    //FlatUser
    getFlatUsers(sieveString: SieveString): Observable<IPataviumPagedResponse<IFlatUser>> {
        return this.http.get<IPataviumPagedResponse<IFlatUser>>(
            environment.apiUrl + '/users/flat' + sieveString.toString()
        );
    }

    getSuggestUsers(sieveString: SieveString): Observable<IPataviumPagedResponse<IVeryShortUser>> {
        return this.http.get<IPataviumPagedResponse<IVeryShortUser>>(
            environment.apiUrl + '/users/suggest' + sieveString.toString()
        );
    }

    getUser(id: number): Observable<IPataviumResponseFirstItem<IUserWithAnagraphic>> {
        return this.http
            .get<IPataviumPagedResponse<IUserWithAnagraphic>>(environment.apiUrl + '/users/' + id)
            .pipe(map(response => new PataviumPagedResponseFirstItem(response)));
    }

    //TODO: pulire i file dove compare createUser(<IUserInfoCreate>
    createUser(user: IUserInfoCreate): Observable<IPataviumResponseFirstItem<IUserWithAnagraphic>> {
        return this.http
            .post<IPataviumPagedResponse<IUserWithAnagraphic>>(environment.apiUrl + '/users', user)
            .pipe(map(response => new PataviumPagedResponseFirstItem(response)));
    }

    //TODO: pulire i file dove compare updateUser(<IUserWithAnagraphicGroup>
    updateUser(
        body: IUserWithAnagraphicGroup
    ): Observable<IPataviumResponseFirstItem<IUserWithAnagraphic>> {
        console.debug(`Updating user: `, body);
        return this.http
            .put<IPataviumPagedResponse<IUserWithAnagraphic>>(environment.apiUrl + '/users', body)
            .pipe(map(response => new PataviumPagedResponseFirstItem(response)));
    }

    removeUser(id: number): Observable<IPataviumResponseFirstItem<IUserWithAnagraphic>> {
        return this.http
            .delete<IPataviumPagedResponse<IUserWithAnagraphic>>(environment.apiUrl + '/users/' + id)
            .pipe(map(response => new PataviumPagedResponseFirstItem(response)));
    }

    uploadAvatar(
        id: number,
        body: FormData
    ): Observable<IPataviumResponseFirstItem<PairUsersAvatar>> {
        return this.http
            .put<IPataviumPagedResponse<PairUsersAvatar>>(
                environment.apiUrl + '/users/' + id + '/avatar',
                body,
                {
                    reportProgress: true
                }
            )
            .pipe(map(response => new PataviumPagedResponseFirstItem(response)));
    }

    /** CONTRACTS #################################################################################*/

    /** PRICELISTS ################################################################################*/
    getPricelists(sieveString: SieveString): Observable<IPataviumPagedResponse<ICatalog>> {
        return this.http.get<IPataviumPagedResponse<ICatalog>>(
            environment.apiUrl + '/catalogs' + sieveString.toString()
        );
    }

    getLinkedPricelistById(
        id: number,
        type: CatalogType
    ): Observable<IPataviumResponseFirstItem<ICatalogWithInfo>> {
        return this.http
            .get<IPataviumPagedResponse<ICatalogWithInfo>>(
                environment.apiUrl + '/catalogs/' + id + '/type/' + type + '/linked/users'
            )
            .pipe(map(response => new PataviumPagedResponseFirstItem(response)));
    }

    getSuggestPricelistsWithType(
        catalogType: CatalogType,
        sieveString: SieveString,
        userId?: number
    ): Observable<IPataviumPagedResponse<IVeryShortCatalog>> {
        sieveString.addFilters([
            {
                key: SieveFilter.Catalog.EnergyOrGas,
                operator: SieveOperator.Equal,
                value: catalogType
            }
        ]);
        const params = new HttpParams({
            fromString: sieveString.withQuestionMark(false).toString()
        });
        let url = environment.apiUrl + '/catalogs/suggest';
        if (userId != null) {
            url = url + `/user/${userId}`;
        }
        return this.http.get<IPataviumPagedResponse<IVeryShortCatalog>>(url, { params });
    }

    getPricelistById(
        id: number,
        type: CatalogType
    ): Observable<IPataviumResponseFirstItem<ICatalogWithInfo>> {
        return this.http
            .get<IPataviumPagedResponse<ICatalogWithInfo>>(
                environment.apiUrl + '/catalogs/' + id + '/type/' + type
            )
            .pipe(map(response => new PataviumPagedResponseFirstItem(response)));
    }

    associatePricelist(body: AssocUserCatalog): Observable<IPataviumResponseFirstItem<ICatalog>> {
        return this.http
            .put<IPataviumPagedResponse<ICatalog>>(environment.apiUrl + '/catalogs/link/true', body)
            .pipe(map(response => new PataviumPagedResponseFirstItem(response)));
    }

    dissociatePricelist(body: AssocUserCatalog): Observable<IPataviumResponseFirstItem<ICatalog>> {
        return this.http
            .put<IPataviumPagedResponse<ICatalog>>(environment.apiUrl + '/catalogs/link/false', body)
            .pipe(map(response => new PataviumPagedResponseFirstItem(response)));
    }

    /** DOCUMENTS #################################################################################*/
    getDocuments(sieveString: SieveString): Observable<IPataviumPagedResponse<ITableStorageInfo>> {
        return this.http.get<IPataviumPagedResponse<ITableStorageInfo>>(
            environment.apiUrl + '/files' + sieveString.toString()
        );
    }

    uploadDocument(file: File, description: string, idOwner: number, timestampInfos: ITimestampInfos, timestamped: boolean = false): Observable<IPataviumResponseFirstItem<StorageFile>> {
        const body = new FormData();
        body.append('file', file, file.name);
        body.append('description', description);
        body.append('idOwner', idOwner.toString());
        body.append('timestamped', timestamped.toString());
        body.append('timestampInfos', JSON.stringify(timestampInfos));
        const fileUploadUrl = `${environment.apiUrl}/files`;
        return this.http.post<IPataviumPagedResponse<StorageFile>>(fileUploadUrl, body, {
            reportProgress: true
        }).pipe(map(response => new PataviumPagedResponseFirstItem(response, StorageFile)));
    }

    uploadCtePriceList(
        body: FormData,
        idCatalog: number
    ): Observable<IPataviumPagedResponse<ICatalogWithInfo>> {
        return this.http.put<IPataviumPagedResponse<ICatalogWithInfo>>(
            environment.apiUrl + '/catalogs/' + idCatalog + '/cte',
            body,
            {
                reportProgress: true
            }
        );
    }

    private associationOrDissociationDoc(bool: boolean, body: IFileUserLink) {
        return this.http
            .put<IPataviumPagedResponse<StorageFile>>(environment.apiUrl + '/files/link/' + bool, body)
            .pipe(map(response => new PataviumPagedResponseFirstItem(response)));
    }

    associateDocument(body: IFileUserLink): Observable<IPataviumResponseFirstItem<StorageFile>> {
        return this.associationOrDissociationDoc(true, body);
    }

    dissociateDocument(body: IFileUserLink): Observable<IPataviumResponseFirstItem<StorageFile>> {
        return this.associationOrDissociationDoc(false, body);
    }

    removeDocument(id: number): Observable<IPataviumResponseFirstItem<StorageFile>> {
        return this.http
            .delete<IPataviumPagedResponse<StorageFile>>(environment.apiUrl + '/files/' + id)
            .pipe(map(response => new PataviumPagedResponseFirstItem(response)));
    }

    removeCteFile(
        idCatalog: number,
        idFile: number
    ): Observable<IPataviumResponseFirstItem<StorageFile>> {
        return this.http
            .delete<IPataviumPagedResponse<StorageFile>>(
                environment.apiUrl + '/catalogs/' + idCatalog + '/cte/' + idFile
            )
            .pipe(map(response => new PataviumPagedResponseFirstItem(response)));
    }

    getUsersLinkedFile(id: number): Observable<IPataviumPagedResponse<IFileWithInfo>> {
        return this.http.get<IPataviumPagedResponse<IFileWithInfo>>(
            environment.apiUrl + '/files/' + id + '/linked/users'
        );
    }

    /** CUSTOMERS #################################################################################*/
    getCustomers(
        sieveString: SieveString
    ): Observable<IPataviumPagedResponse<IShadowGenericAnagraphic>> {
        return this.http.get<IPataviumPagedResponse<IShadowGenericAnagraphic>>(
            environment.apiUrl + '/customers' + sieveString.toString()
        );
    }

    getCustomersFromAgent(
        idAgent: number,
        contractBrand: BrandType,
        sieveString: SieveString): Observable<IPataviumPagedResponse<IShadowGenericAnagraphic>> {
        const brand = contractBrand == null ? -1 : contractBrand;
        return this.http.get<IPataviumPagedResponse<IShadowGenericAnagraphic>>(
            `${environment.apiUrl}/customers/user/${idAgent}/contract-brand/${brand}` + sieveString.toString()
        );
    }

    getCustomersFromAgentForReferral(
        idAgent: number,
        contractBrand: BrandType,
        sieveString: SieveString): Observable<IPataviumPagedResponse<IShadowGenericAnagraphic>> {
        const brand = contractBrand == null ? -1 : contractBrand;
        return this.http.get<IPataviumPagedResponse<IShadowGenericAnagraphic>>(
            `${environment.apiUrl}/customers/user/${idAgent}/contract-brand/${brand}/referral` + sieveString.toString()
        );
    }

    //NOT USED YET
    getCustomer(id: number): Observable<IPataviumResponseFirstItem<IShadowGenericAnagraphic>> {
      return this.http
        .get<IPataviumPagedResponse<IShadowGenericAnagraphic>>(
          environment.apiUrl + "/customers/" + id
        )
        .map(response => new PataviumPagedResponseFirstItem(response));
    }

    createOrUpdateCustomer(
        body: IShadowCustomerCreate
    ): Observable<IPataviumResponseFirstItem<IShadowGenericAnagraphic>> {
        return this.http
            .put<IPataviumPagedResponse<IShadowGenericAnagraphic>>(
                environment.apiUrl + '/customers',
                body
            )
            .pipe(map(response => new PataviumPagedResponseFirstItem(response)));
    }
    

    removeCustomer(id: number): Observable<IPataviumResponseFirstItem<IShadowGenericAnagraphic>> {
        return this.http
            .delete<IPataviumPagedResponse<IShadowGenericAnagraphic>>(
                environment.apiUrl + '/customers/' + id
            )
            .pipe(map(response => new PataviumPagedResponseFirstItem(response)));
    }

    checkByTaxCode(id: number): Observable<IPortaUnAmicoResponse> {
        return this.http.get<IPortaUnAmicoResponse>(environment.apiUrl + '/customers/portaunamico/check/' + id);
    }

    addPortaUnAmico(id: number, userId: number): Observable<IPortaUnAmicoResponse> {
        return this.http.get<IPortaUnAmicoResponse>(`${environment.apiUrl}/customers/portaunamico/${id}/${userId}`);
    }

    associatePortaUnAmico(id: number, userId: number, referral: number): Observable<IPortaUnAmicoResponse> {
        return this.http.get<IPortaUnAmicoResponse>(`${environment.apiUrl}/customers/portaunamico/link/${id}/${userId}/${referral}`);
    }


    invitePortaUnAmico(request: IInviteRequest): Observable<IInviteResponse> {
        return this.http.post<IInviteResponse>(environment.apiUrl + '/customers/portaunamico/invite', request);
    }

    /** GEOS #################################################################################*/
    getLikeNameCity(nameCity: string): Observable<IPataviumPagedResponse<ICity>> {
        return this.http
            .get<IPataviumPagedResponse<ICityResponse>>(environment.apiUrl + '/geos/cities', {
                params: {
                    name: nameCity
                },
                reportProgress: false
            })
            .pipe(map(response => new PataviumPagedResponse(response, City)));
    }

    getLikeNameProvince(nameProv: string) {
        return this.http.get<IPataviumPagedResponse<IProvinceResponse>>(
            environment.apiUrl + '/geos/provinces',
            {
                params: {
                    name: nameProv
                },
                reportProgress: false
            }
        );
    }

    getSuppliers(sieveString: SieveString) {
        return this.http.get<IPataviumPagedResponse<ISupplierResponse>>(
            environment.apiUrl + '/enerp/suppliers' + sieveString.toString()
        );
    }

    getDistributors(sieveString: SieveString): Observable<IPataviumPagedResponse<IVendorResponse>> {
        return this.http.get<IPataviumPagedResponse<IVendorResponse>>(
            environment.apiUrl + '/enerp/distributors' + sieveString.toString()
        );
    }

    getVatExemptions() {
        const url = `${environment.apiUrl}/enerp/vat-exemptions`;
        return this.http.get<IPataviumPagedResponse<IVatExemptionDto>>(url);
    }

    podIsBusy(podCode: string): Observable<IPataviumResponse<boolean>> {
        const url = `${environment.apiUrl}/enerp/pods/${podCode}/is-busy`;
        return this.http.get<IPataviumResponse<boolean>>(url);
    }

    pdrIsBusy(pdrCode: string): Observable<IPataviumResponse<boolean>> {
        const url = `${environment.apiUrl}/enerp/pdrs/${pdrCode}/is-busy`;
        return this.http.get<IPataviumResponse<boolean>>(url);
    }

    enableOrDisableUser(
        idUser: number,
        enabled: boolean
    ): Observable<IPataviumPagedResponse<IUserWithAnagraphic>> {
        return this.http.put<IPataviumPagedResponse<IUserWithAnagraphic>>(
            environment.apiUrl + '/users/' + idUser + '/enabled/' + enabled,
            null
        );
    }

    getAvatarCurrentUser(): Observable<IPataviumPagedResponse<PairUsersAvatar>> {
        return this.http.get<IPataviumPagedResponse<PairUsersAvatar>>(
            environment.apiUrl + '/users/me/avatar'
        );
    }

    getUsersNotificationCatalog(
        idCatalog: number,
        type: CatalogType
    ): Observable<IPataviumPagedResponse<INotificationListResponse>> {
        return this.http.get<IPataviumPagedResponse<INotificationListResponse>>(
            environment.apiUrl + '/notifications/catalog/' + idCatalog + '/type/' + type
        );
    }

    /* LOCK */

    private createLock(lockRequest: ICreateLockRequest): Observable<ICreateLockResponse> {
        return this.http.post<ICreateLockResponse>(`${environment.apiUrl}/lock`, lockRequest);
    }
    private refreshLock(
        lockId: number,
        refreshLockRequest: IRefreshLockRequest
    ): Observable<number> {
        return this.http.patch<number>(`${environment.apiUrl}/lock/${lockId}`, refreshLockRequest);
    }
    lockEntity(lockRequest: ICreateLockRequest): Observable<number> {
        return this.createLock(lockRequest).pipe(
            switchMap(resp =>
                timer(0, resp.refreshPeriodMs).pipe(
                    concatMapTo(
                        this.refreshLock(resp.lockId, {
                            refreshTimeSpanMs: resp.refreshTimeSpanMs,
                            lockedEntity: lockRequest.lockedEntity,
                            lockedEntityType: lockRequest.lockedEntityType
                        })
                    )
                )
            )
        );
    }

    deleteLock(lockId: number): Observable<number> {
        return this.http.delete<number>(`${environment.apiUrl}/lock/${lockId}`).pipe(
            retryWhen(errors =>
                errors.pipe(
                    mergeMap((error, index) => {
                        if (
                            error instanceof HttpErrorResponse &&
                            error.status === 409 &&
                            index < 5
                        ) {
                            return timer(index * 100);
                        }
                        throwError(error);
                    })
                )
            )
        );
    }

    getSupplyOffersByFamilyAndSupplyType(
        family: string,
        supplyType: SupplyType
    ): Observable<IPataviumPagedResponse<ISupplyOffer>> {
        return this.http.get<IPataviumPagedResponse<ISupplyOffer>>(
            `${environment.apiUrl}/supply-offers/${family}/${supplyType}`
        );
    }
    createContractsFromCsv(file: File, fileType: ContractCreationFileType): Observable<ContractsCreationFromCsvResponse> {
        const body = new FormData();
        body.append('data', file, file.name);
        let urlFragment = null;
        switch (fileType) {
            case ContractCreationFileType.Csv1Ee:
                urlFragment = 'csv1ee';
                break;
            case ContractCreationFileType.Csv1Gg:
                urlFragment = 'csv1gg';
                break;
            case ContractCreationFileType.Csv2Ee:
                urlFragment = 'csv2ee';
                break;
            case ContractCreationFileType.Csv2Gg:
                urlFragment = 'csv2gg';
                break;

            default:
                return throwError(`Valore ${fileType} non gestito`);
        }
        const url = `${environment.apiUrl}/contracts/from-file/${urlFragment}`;
        return this.http.post<IPataviumResponse<IContractsCreationFromCsvResponse>>(url, body)
            .pipe(map(resp => new ContractsCreationFromCsvResponse(resp.payload)));
    }

    uploadAreraFile(file: File, fileType: AreraFileType, catalogId: number, partitionName: AreraGeoPartitionName): Observable<IPataviumResponse<ICatalogAreraGasGeoPartitionFileResp>> {
        const body: FormData = new FormData();
        body.append('areraFile', file, file.name);
        body.append('areraFileType', fileType);
        body.append('catalogId', catalogId.toString());
        body.append('partitionName', partitionName);
        const url = `${environment.apiUrl}/catalogs/upload-arera-file`;
        return this.http.post<IPataviumResponse<ICatalogAreraGasGeoPartitionFileResp>>(url, body);
    }

    removeAreraFile(fileId: number, fileType: AreraFileType, catalogId: number, partitionName: AreraGeoPartitionName): Observable<void> {
        const url = `${environment.apiUrl}/catalogs/${catalogId}/arera-files/${fileId}-${fileType}/partition-name/${partitionName}`;
        return this.http.delete<void>(url);
    }


    getLinkedCustomers(customerId: number): Observable<IPataviumPagedResponse<IPairAnagraphicUserRole>> {
        return this.http.get<IPataviumPagedResponse<IPairAnagraphicUserRole>>(
            `${environment.apiUrl}/customers/linked/${customerId}`
        );
    }

    getLinkedCustomersForUser(userId: number): Observable<IPataviumPagedResponse<IPairAnagraphicUserRole>> {
        return this.http.get<IPataviumPagedResponse<IPairAnagraphicUserRole>>(
            `${environment.apiUrl}/customers/linked/user/${userId}`
        );
    }


    unlinkCustomer(customerId: number, userId: number): Observable<IPataviumPagedResponse<boolean>> {
        return this.http.get<IPataviumPagedResponse<boolean>>(
            `${environment.apiUrl}/customers/unlink/${customerId}/${userId}`
        );
    }


    // sms templates
    getTemplates(): Promise<ISms[]> {
        return this.http.get<ISms[]>(environment.apiUrl + '/template/list').toPromise();
    }

    getTemplate(id:number): Promise<ISms> {
        return this.http.get<ISms>(environment.apiUrl + '/template/get/' + id).toPromise();
    }

    addTemplate(body: ISms): Promise<number> {
        return this.http.post<number>(environment.apiUrl + '/template/create', body).toPromise();
    }

    updateTemplate(body: ISms): Promise<number> {
        return this.http.patch<number>(environment.apiUrl + '/template/update', body).toPromise();
    }

    removeTemplate(id: number): Promise<number> {
        return this.http.delete<number>(environment.apiUrl + '/template/remove/' + id).toPromise();
    }

    linkTemplate(body: any): Promise<number> { // id template e array ids utenti a cui linkarlo
        return this.http.post<number>(environment.apiUrl + '/template/link', body).toPromise();
    }

    getTemplateUser(id:number): Promise<ISmsUsers> {
        return this.http.get<ISmsUsers>(environment.apiUrl + '/template/linked/' + id).toPromise();
    }

    getUsersByRole(role:PataviumRole): Promise<IUser[]> {
        return this.http.get<IUser[]>(environment.apiUrl + '/template/users/' + role).toPromise();
    }

}



// WEBPACK FOOTER //
// ./src/app/services/data.service.ts